import request from '@/utils/request'

export function addRobot(data) {
  return request({
    url: 'api/v1/robot/addRobot',
    method: 'post',
    data: data,
    timeout: 10000 * 5
  })
}

export function getRobot(data) {
  return request({
    url: 'api/v1/robot/getRobot',
    method: 'post',
    data: data
  })
}

export function updateRobot(data) {
  return request({
    url: 'api/v1/robot/updateRobot',
    method: 'post',
    data: data
  })
}

export function delRobot(data) {
  return request({
    url: 'api/v1/robot/delRobot',
    method: 'post',
    data: data
  })
}

export function getSlotDataList(data) {
  return request({
    url: 'api/v1/robot/getSlotTestList',
    method: 'post',
    data: data
  })
}
export function getBotStatDataList(data) {
  return request({
    url: 'api/v1/robot/getBotStatList',
    method: 'post',
    data: data
  })
}
